import { useState } from 'react';
import Layout from '../../../components/feature/Layout';

interface Contact {
  id: string;
  name: string;
  company: string;
  position: string;
  email: string;
  phone: string;
  status: 'Activo' | 'Inactivo';
}

export default function ContactsPage() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedContact, setSelectedContact] = useState<Contact | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCompany, setFilterCompany] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');

  const contacts: Contact[] = [
    { id: 'CT-001', name: 'María González', company: 'Importadora del Pacífico S.A.', position: 'Gerente de Logística', email: 'mgonzalez@pacifico.com', phone: '+502 2345-6789', status: 'Activo' },
    { id: 'CT-002', name: 'Carlos Méndez', company: 'Exportadora Central', position: 'Director de Operaciones', email: 'cmendez@central.com', phone: '+502 2456-7890', status: 'Activo' },
    { id: 'CT-003', name: 'Ana Rodríguez', company: 'Global Trade Solutions', position: 'Coordinadora de Importaciones', email: 'arodriguez@gts.com', phone: '+502 2567-8901', status: 'Activo' },
    { id: 'CT-004', name: 'Roberto Castillo', company: 'Comercial Atlántico', position: 'Jefe de Compras', email: 'rcastillo@atlantico.com', phone: '+502 2678-9012', status: 'Activo' },
    { id: 'CT-005', name: 'Laura Morales', company: 'Importadora del Pacífico S.A.', position: 'Asistente Administrativa', email: 'lmorales@pacifico.com', phone: '+502 2789-0123', status: 'Activo' },
    { id: 'CT-006', name: 'Diego Herrera', company: 'Textiles Modernos S.A.', position: 'Gerente General', email: 'dherrera@textiles.com', phone: '+502 2890-1234', status: 'Activo' },
    { id: 'CT-007', name: 'Patricia Vega', company: 'Exportadora Central', position: 'Asistente de Logística', email: 'pvega@central.com', phone: '+502 2901-2345', status: 'Inactivo' },
    { id: 'CT-008', name: 'Fernando López', company: 'Alimentos Premium', position: 'Director Comercial', email: 'flopez@premium.com', phone: '+502 3012-3456', status: 'Activo' },
  ];

  const companies = ['Todas', ...Array.from(new Set(contacts.map(c => c.company)))];

  const filteredContacts = contacts.filter(contact => {
    const matchesSearch = contact.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         contact.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         contact.company.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCompany = filterCompany === 'all' || contact.company === filterCompany;
    const matchesStatus = filterStatus === 'all' || contact.status === filterStatus;
    return matchesSearch && matchesCompany && matchesStatus;
  });

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-[#0A2A43]">Contactos</h1>
            <p className="text-sm text-gray-500 mt-1">Directorio general de contactos</p>
          </div>
          <button
            onClick={() => setShowCreateModal(true)}
            className="px-4 py-2.5 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-lg hover:shadow-lg transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-add-line text-lg"></i>
            Nuevo Contacto
          </button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">Total Contactos</p>
                <p className="text-2xl font-bold text-[#0A2A43] mt-1">{contacts.length}</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-contacts-line text-2xl text-[#2F80ED]"></i>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">Contactos Activos</p>
                <p className="text-2xl font-bold text-[#0A2A43] mt-1">{contacts.filter(c => c.status === 'Activo').length}</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-user-line text-2xl text-[#10B981]"></i>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">Empresas</p>
                <p className="text-2xl font-bold text-[#0A2A43] mt-1">{companies.length - 1}</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-building-line text-2xl text-[#114B7A]"></i>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">Nuevos este mes</p>
                <p className="text-2xl font-bold text-[#0A2A43] mt-1">12</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-user-add-line text-2xl text-[#EAB308]"></i>
              </div>
            </div>
          </div>
        </div>

        {/* Filters */}
        <div className="bg-white rounded-lg p-4 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="md:col-span-2">
              <div className="relative">
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
                <input
                  type="text"
                  placeholder="Buscar por nombre, email o empresa..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent text-sm"
                />
              </div>
            </div>
            <div>
              <select
                value={filterCompany}
                onChange={(e) => setFilterCompany(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent text-sm cursor-pointer"
              >
                <option value="all">Todas las empresas</option>
                {companies.slice(1).map(company => (
                  <option key={company} value={company}>{company}</option>
                ))}
              </select>
            </div>
            <div>
              <select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent text-sm cursor-pointer"
              >
                <option value="all">Todos los estados</option>
                <option value="Activo">Activo</option>
                <option value="Inactivo">Inactivo</option>
              </select>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)] overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-[#EAF2F8]">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Nombre</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Empresa</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Cargo</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Email</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Teléfono</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Estado</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Acciones</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {filteredContacts.map((contact) => (
                  <tr key={contact.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#114B7A] to-[#2F80ED] flex items-center justify-center text-white font-semibold text-sm">
                          {contact.name.split(' ').map(n => n[0]).join('')}
                        </div>
                        <div>
                          <p className="text-sm font-medium text-[#0A2A43]">{contact.name}</p>
                          <p className="text-xs text-gray-500">{contact.id}</p>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <p className="text-sm text-[#0A2A43]">{contact.company}</p>
                    </td>
                    <td className="px-6 py-4">
                      <p className="text-sm text-[#0A2A43]">{contact.position}</p>
                    </td>
                    <td className="px-6 py-4">
                      <p className="text-sm text-[#0A2A43]">{contact.email}</p>
                    </td>
                    <td className="px-6 py-4">
                      <p className="text-sm text-[#0A2A43]">{contact.phone}</p>
                    </td>
                    <td className="px-6 py-4">
                      <span className={`px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
                        contact.status === 'Activo'
                          ? 'bg-[#D1FAE5] text-[#065F46]'
                          : 'bg-gray-100 text-gray-600'
                      }`}>
                        {contact.status}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2">
                        <button
                          onClick={() => {
                            setSelectedContact(contact);
                            setShowDetailModal(true);
                          }}
                          className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-[#EAF2F8] text-[#2F80ED] transition-colors cursor-pointer"
                          title="Ver detalle"
                        >
                          <i className="ri-eye-line text-lg"></i>
                        </button>
                        <button
                          className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-[#EAF2F8] text-[#114B7A] transition-colors cursor-pointer"
                          title="Editar"
                        >
                          <i className="ri-edit-line text-lg"></i>
                        </button>
                        <button
                          className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-red-50 text-red-600 transition-colors cursor-pointer"
                          title="Eliminar"
                        >
                          <i className="ri-delete-bin-line text-lg"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Create Modal */}
        {showCreateModal && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
                <h2 className="text-xl font-bold text-[#0A2A43]">Nuevo Contacto</h2>
                <button
                  onClick={() => setShowCreateModal(false)}
                  className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-xl text-gray-500"></i>
                </button>
              </div>
              <div className="p-6 space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-[#0A2A43] mb-1">Nombre Completo *</label>
                    <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent text-sm" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#0A2A43] mb-1">Empresa *</label>
                    <select className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent text-sm cursor-pointer">
                      <option>Seleccionar empresa</option>
                      {companies.slice(1).map(company => (
                        <option key={company}>{company}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-[#0A2A43] mb-1">Cargo *</label>
                    <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent text-sm" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#0A2A43] mb-1">Teléfono *</label>
                    <input type="tel" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent text-sm" />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#0A2A43] mb-1">Email *</label>
                  <input type="email" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent text-sm" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#0A2A43] mb-1">Estado</label>
                  <select className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent text-sm cursor-pointer">
                    <option>Activo</option>
                    <option>Inactivo</option>
                  </select>
                </div>
              </div>
              <div className="sticky bottom-0 bg-gray-50 px-6 py-4 flex items-center justify-end gap-3 border-t border-gray-200">
                <button
                  onClick={() => setShowCreateModal(false)}
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Cancelar
                </button>
                <button
                  onClick={() => setShowCreateModal(false)}
                  className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-lg hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
                >
                  Crear Contacto
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Detail Modal */}
        {showDetailModal && selectedContact && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
                <h2 className="text-xl font-bold text-[#0A2A43]">Detalle del Contacto</h2>
                <button
                  onClick={() => setShowDetailModal(false)}
                  className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-xl text-gray-500"></i>
                </button>
              </div>
              <div className="p-6 space-y-6">
                <div className="flex items-center gap-4">
                  <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#114B7A] to-[#2F80ED] flex items-center justify-center text-white font-bold text-2xl">
                    {selectedContact.name.split(' ').map(n => n[0]).join('')}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#0A2A43]">{selectedContact.name}</h3>
                    <p className="text-sm text-gray-500">{selectedContact.id}</p>
                    <span className={`inline-block mt-2 px-2.5 py-1 rounded-full text-xs font-medium ${
                      selectedContact.status === 'Activo'
                        ? 'bg-[#D1FAE5] text-[#065F46]'
                        : 'bg-gray-100 text-gray-600'
                    }`}>
                      {selectedContact.status}
                    </span>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Empresa</p>
                    <p className="text-sm font-medium text-[#0A2A43]">{selectedContact.company}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Cargo</p>
                    <p className="text-sm font-medium text-[#0A2A43]">{selectedContact.position}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Email</p>
                    <p className="text-sm font-medium text-[#0A2A43]">{selectedContact.email}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Teléfono</p>
                    <p className="text-sm font-medium text-[#0A2A43]">{selectedContact.phone}</p>
                  </div>
                </div>
              </div>
              <div className="sticky bottom-0 bg-gray-50 px-6 py-4 flex items-center justify-end gap-3 border-t border-gray-200">
                <button
                  onClick={() => setShowDetailModal(false)}
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Cerrar
                </button>
                <button className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-lg hover:shadow-lg transition-all whitespace-nowrap cursor-pointer">
                  Editar Contacto
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}